export default __webpack_public_path__ + "static/image14-461d16aac39087a3a7a2d62dd910ac49.jpg";